var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isTxSuccess, isGasError, getTxErrorMessage } from './txResult';
// Dry-runs a transaction before signing to catch failures early.
export function dryRunTransaction(transactionBlock, address, suiClient) {
    return __awaiter(this, void 0, void 0, function* () {
        var _a, _b;
        transactionBlock.setSender(address);
        const result = yield suiClient.simulateTransaction({
            transaction: yield transactionBlock.build({ client: suiClient }),
            include: { effects: true },
        });
        const effects = (_b = ((_a = result.Transaction) !== null && _a !== void 0 ? _a : result.FailedTransaction)) === null || _b === void 0 ? void 0 : _b.effects;
        if (isTxSuccess(result)) {
            return { success: true, effects };
        }
        // Accounts whose funds live in the Sui address-balance accumulator have no SUI
        // coin objects, so the client-side build can't resolve a gas payment and the
        // simulation reports InsufficientGas. There is no public client API to pay gas
        // from the accumulator — the wallet does that at execution time (which is why
        // such accounts work elsewhere). So a gas error in the dry-run is NOT a real
        // failure: let it through and rely on the authoritative sign result. The supply
        // asset itself is already sourced from the accumulator via coinWithBalance.
        if (isGasError(result)) {
            return { success: true, effects };
        }
        return {
            success: false,
            rawError: getTxErrorMessage(result) || 'Transaction simulation failed',
            effects,
        };
    });
}
